/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import type { AdvertorialConfig } from '../types/advertorial';
import type {
  AdRules,
  AdUnitTransformerConfig,
  PropertyConfig,
  SiteEnabledFeature,
} from '../types/index';

class SiteConfig {
  private static _instance: SiteConfig | null = null;
  private _info: PropertyConfig;

  private constructor(info: PropertyConfig) {
    this._info = info;
  }

  public static getInstance(info?: PropertyConfig): SiteConfig {
    if (!SiteConfig._instance) {
      if (!info) {
        throw new Error('SiteConfig must be initialised with Property configuration');
      }
      SiteConfig._instance = new SiteConfig(info);
    }
    return SiteConfig._instance;
  }

  public get id(): string {
    return this._info.id;
  }

  public get nodalsAdvertiserId(): string {
    return this._info.advid || '';
  }

  public get directLearningAdvertiserIgnoreList(): string[] {
    return this._info.dlail || [];
  }

  public get contentQuerySelectors(): string {
    return this._info.ctslctrs || '';
  }

  public hasFeatureEnabled(feature: SiteEnabledFeature): boolean {
    return Boolean(this._info[feature]);
  }

  public get maxRecordedAuctions(): number {
    return this._info.maxRecordedAuctions ?? (this.id === 'f07f066b' ? 5 : 0);
  }

  public get advertorialConfig(): AdvertorialConfig | undefined {
    return this._info.advtl;
  }

  public get userIdEidSource(): string | undefined {
    return this._info.eidsrc;
  }

  public get adUnitTransformerConfig(): AdUnitTransformerConfig | undefined {
    return this._info.adUnitTransformer;
  }

  public get targetingRules(): AdRules | undefined {
    return this._info.rules;
  }
}

export { SiteConfig };
